import { ContainersApi, ImportContainerRequest } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class ContainersService {
  private readonly httpClient = createApiClient(ContainersApi)

  async importBatch(requests: ImportContainerRequest[]): Promise<void> {
    await this.httpClient.importBatch(requests)
  }
}

export const containersService = new ContainersService()
